var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoorVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "58px",
    viewBox: "0 0 34 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receipt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.37,0.4 L5.63,0.4 C2.75353513,0.4 0.4,2.53935396 0.4,5.209 L0.4,52.967 C0.4,55.6367885 2.75370595,57.777 5.63,57.777 L28.37,57.777 C31.2469664,57.777 33.6,55.6370806 33.6,52.967 L33.6,5.209 C33.6,2.53906193 31.2471372,0.4 28.37,0.4 Z M5.63,1.6 L28.37,1.6 C30.6085556,1.6 32.4,3.22865875 32.4,5.209 L32.4,52.967 C32.4,54.9475804 30.6083067,56.577 28.37,56.577 L5.63,56.577 C3.39233015,56.577 1.6,54.9472443 1.6,52.967 L1.6,5.209 C1.6,3.22899469 3.39208131,1.6 5.63,1.6 Z",
    id: "Stroke-1",
    fill: "#1E5B53",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,49 L11,51 L9,51 L9,53 L7,53 L7,49 L11,49 Z M18,49 L18,53 L14,53 L14,49 L18,49 Z M27,49 L27,53 L23,53 L23,49 L27,49 Z M11,38 L11,42 L14,42 L14,44 L6,44 L6,45 L4,45 L4,44 L1,44 L1,42 L5,42 L5,38 L11,38 Z M33,40 L33,42 L26,42 L26,40 L33,40 Z M31,18 L31,20 L24,20 L24,18 L31,18 Z M8,12 L8,14 L1,14 L1,12 L8,12 Z M27,7 L27,9 L20,9 L20,7 L27,7 Z M26,38 L26,40 L22,40 L22,38 L26,38 Z M14,33 L14,36 L22,36 L22,38 L13,38 L13,36 L12,36 L12,33 L14,33 Z M22,27.5 L22,33.5 L20,33.5 L20,27.5 L22,27.5 Z M12,14 L12,23 L9,23 L8.999,22 L7,22 L7,16 L9,16 L9,14 L12,14 Z M26,14 L26,23 L23,23 L23,14 L26,14 Z M23,11 L23,14 L12,14 L12,11 L23,11 Z M9,8 L9,10 L7,10 L7,8 L9,8 Z M3,10 L3,12 L1,12 L1,10 L3,10 Z M20,5 L20,7 L18,7 L18,5 L20,5 Z",
    id: "Shape",
    fill: "#1E5B53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#88DECB",
    points: "23 14 23 23 25 23 25 26 23 26 23 28 20 28 20 36 14 36 14 28 12 28 12 26 10 26 10 23 12 23 12 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49-Copy",
    fill: "#28449F",
    points: "19 21 21 21 21 19 19 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39-Copy-3",
    fill: "#28449F",
    points: "15 27 17 27 17 25 15 25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#28449F",
    points: "12 21 16 21 16 19 12 19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoorVideo);
export default __webpack_public_path__ + "static/media/poor_video.f61fc106c005323bef7e568e5300bd51.svg";
export { ForwardRef as ReactComponent };